
















































































import { Meta } from "@/store/meta"
import { Component } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import { mixins } from "vue-class-component"
import { Dictionary } from "@/mixins/dictionary"
import { DateTime } from "@/mixins/datetime"
@Component({
})
export default class PaymentsDetail extends mixins(Dictionary, DateTime) {
  id = -1

  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get paymentDetail() {
    return this.server.PaymentsDatum
  }
  
  async mounted() {
    this.id = parseInt(this.$route.params.id as string)
    await this.server.getPaymentsDetail(this.id.toString())
  }

  print(){
    print()
  }
}
